export const isValidHex = (hexColor: string) => {
  return /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{4}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(hexColor);
};

export const hexToRgba = (hexValue: string) => {
  let hex = hexValue.replace(/^#/, '');

  if (hex.length === 3) {
    hex = hex
      .split('')
      .map((char) => char + char)
      .join('');
  }

  let a = 1;
  if (hex.length === 8) {
    a = parseInt(hex.slice(6, 8), 16) / 255;
    hex = hex.slice(0, 6);
  }

  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  return {r, g, b, a};
};

export const rgbaToHex = (rgba: {r: number; g: number; b: number; a?: number}) => {
  const {r, g, b, a = 1} = rgba;
  const alphaHex = Math.round(a * 255)
    .toString(16)
    .padStart(2, '0')
    .toUpperCase();
  return `#${((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1).toUpperCase()}${alphaHex}`;
};

export const getAlphaPercentFromHex = (hexColor: string) => {
  const hex = hexColor.replace(/^#/, '');

  if (hex.length === 8) {
    const alphaHex = hex.slice(6, 8);
    const alphaDecimal = parseInt(alphaHex, 16);

    if (isNaN(alphaDecimal)) {
      return 100;
    }

    return Math.round((alphaDecimal / 255) * 100);
  }

  if (hex.length === 6) {
    return 100;
  }

  return 100;
};

export const addAlphaToHex = (hexColor: string, alphaPercent: number) => {
  const hex = hexColor.replace(/^#/, '');

  if (!isValidHex(hexColor) || hex.length !== 6) {
    return hexColor;
  }

  if (alphaPercent < 0 || alphaPercent > 100) {
    return hexColor;
  }

  const alphaDecimal = Math.round((alphaPercent / 100) * 255);

  const alphaHex = alphaDecimal.toString(16).padStart(2, '0').toUpperCase();

  return `#${hex.toUpperCase()}${alphaHex}`;
};
